export function encodeBase64(value: string) {
  return Buffer.from(value).toString('base64');
}

export function decodeBase64(value: string) {
  return new Buffer(value, 'base64').toString();
}



// WEBPACK FOOTER //
// ./src/helpers/base64.ts